import { render, staticRenderFns } from "./GradesEntry.vue?vue&type=template&id=39c5c169"
import script from "./GradesEntry.vue?vue&type=script&lang=js"
export * from "./GradesEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports